import React from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route
  } from 'react-router-dom';

import { Principal } from '../components/principal';

  export const AppRouter = () => {
    return (
        <Router>
            <div>
                <Switch>
                    <Route exact path="/encuesta-destacada" component={ Principal } />
                </Switch>
            </div>
        </Router>
    )
}
